// extracted by mini-css-extract-plugin
export var content = "layout-module--content--155cd";